import { useTranslation } from 'react-i18next';
import { CorporateGroupIdentityConfig } from '../../../../../CorporateGroupIdentityConfigProvider/CorporateGroupIdentityConfigProvider';
import { useToggle } from '../../../../../hooks/useToggle';
import { StandardModal } from '../../../../StandardModal/StandardModal';
import {
  Container,
  IdentityProviderContinueButton,
  IdentityProviderModalButton,
  IdentityProviderLoginButton,
} from './IdentityProviderLoginGroup.styles';

interface Props {
  config: CorporateGroupIdentityConfig;
}

export const IdentityProviderLoginGroup = ({ config }: Props) => {
  const { t } = useTranslation();
  const [showIdentityProviderLoginModal, toggleIdentityProviderLoginModal] = useToggle(false);

  if (config.loginMethods.length > 1) {
    return (
      <>
        <IdentityProviderModalButton onClick={toggleIdentityProviderLoginModal}>
          {t('button.login.loginWithExternalProvider', {
            name: config.name,
          })}
        </IdentityProviderModalButton>
        <StandardModal
          isOpen={showIdentityProviderLoginModal}
          onRequestClose={toggleIdentityProviderLoginModal}
        >
          <Container>
            {config.loginMethods.map(loginMethod => (
              <IdentityProviderContinueButton
                key={loginMethod.displayName}
                options={{ keyline: true }}
                providerId={config.id}
                loginMethod={loginMethod}
                showIcon={true}
              >
                {t('button.login.continueWithExternalProvider', {
                  name: loginMethod.displayName,
                })}
              </IdentityProviderContinueButton>
            ))}
          </Container>
        </StandardModal>
      </>
    );
  } else {
    return (
      <>
        {config.loginMethods.map(loginMethod => (
          <IdentityProviderLoginButton
            key={loginMethod.displayName}
            providerId={config.id}
            loginMethod={loginMethod}
          >
            {t('button.login.loginWithExternalProvider', {
              name: config.name,
            })}
          </IdentityProviderLoginButton>
        ))}
      </>
    );
  }
};
